<template>
  <el-dialog
    custom-class="webpay request"
    :visible.sync="visibleInner"
    top="1vh"
  >
    <span slot="title">
      <h4>{{ $t('add') }}</h4>
    </span>
    <div v-loading="loading">
      <el-form
        ref="requestForm"
        @submit.native.prevent="save"
        :show-message="false"
        :model="model"
        :rules="rules"
      >
        <el-form-item :label="$t('applicant_id')" prop="check_id">
          <el-input v-model="model.check_id" :placeholder="$t('name')" />
        </el-form-item>

        <el-form-item :label="$t('default_template')" prop="template_id">
          <el-select size="mini" v-model="model.template_id" filterable>
            <el-option
              v-for="template in templates"
              :key="template.id"
              :label="template.name"
              :value="template.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('client')" prop="client_id">
          <el-select size="mini" v-model="model.client_id" filterable>
            <el-option
              v-for="client in clients"
              :key="client.id"
              :label="client.name"
              :value="client.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-button
          class="aligner right"
          round
          type="primary"
          native-type="submit"
          >{{ $t('save') }}</el-button
        >
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'request-modal',
  props: ['callback', 'visible'],
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  data() {
    return {
      loading: true,
      model: { template_id: '', client_id: '', check_id: '' },
      templates: [],
      clients: [],
      rules: {
        check_id: { required: true, trigger: 'blur' },
        client_id: { required: true, trigger: 'blur' },
        template_id: { required: true, trigger: 'blur' }
      }
    }
  },
  created() {
    this.loading = true
    apiRes.post(apiRes.idcheckRequests, { action: 'getShortList' }).then(res => {
      res = res.page_vars.res
      this.templates = Object.keys(res.templates).map(id => ({ id: id, name: res.templates[id] }))
      this.clients = Object.keys(res.clients).map(id => ({ id: id, name: res.clients[id] }))
      this.model.template_id = this.templates[0].id
      this.model.client_id = this.clients[0].id
    }).finally(() => { this.loading = false })
  },
  methods: {
    save() {
      this.$refs['requestForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let toSend = { action: 'add' }
          Object.assign(toSend, this.model)
          apiRes
            .post(apiRes.idcheckRequests, toSend)
            .then(res => {
              if (res.page_vars) {
                this.callback(res.page_vars)
                this.visibleInner = false
              }

              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style>
.el-dialog.webpay.request {
  max-width: 532px;
}
</style>
